// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tradingview-widget-copyright {\n    font-size: 0px !important;\n    height: 0px !important;\n    display: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
